import Vue from 'vue'
import Vuex from 'vuex'

import moduleSession from './store/session.js'
import moduleSettings from './store/settings.js'
import moduleData from './store/data.js'
import moduleResponse from './store/response.js'
import modulePage from './store/page.js'
import moduleMemory from './store/memory.js'

Vue.use(Vuex)

export default new Vuex.Store({

	namespaced: true,

	modules: {
        memory: moduleMemory,
		session: moduleSession,
		settings: moduleSettings,
		data: moduleData,
		response: moduleResponse,
		page: modulePage
	},

	getters: {

		session: function(state, getters) {

			return getters['session/get']

		},
    
        memory: function(state, getters) {
    
            return getters['memory/get']
    
        },

		data: function(state, getters) {

			return getters['data/get']

		},

		response: function(state, getters) {

			return getters['response/get']

		},

		settings: function(state, getters) {

			return getters['settings/get']

		},

		page: function(state, getters) {

			return getters['page/get']

		}

	}

})
